import React from "react";
import { resolveStoredUploadPreview } from "lib/storedUploadImage";
import UserAvatar from "components/ui/UserAvatar";

type StudentAvatarProps = {
  name?: string | null;
  image?: string | null;
  imageUrl?: string | null;
  className?: string;
  /** Kept for API compatibility; unused when showing the default SVG image. */
  iconClassName?: string;
};

export default function StudentAvatar({
  name,
  image,
  imageUrl,
  className = "h-10 w-10",
}: StudentAvatarProps) {
  const src = resolveStoredUploadPreview(image, imageUrl);

  return (
    <UserAvatar
      src={src}
      alt={name ?? ""}
      className={`rounded-full object-cover ${className}`}
    />
  );
}
